// The listing itself is fetched by the Table component through its own `src` prop, so this module
// carries only what the Table cannot fetch for itself: the export, and the dashboard's venue list.
export const actions = {
  /**
   * Stream the event feedback export file (XLSX or CSV) for the requested date range and venue.
   * POST, not GET: routes/admin.php registers this endpoint inside the POST-only PII export
   * group alongside newsletter and ticket, unlike the reviews export which is a GET.
   * @param {Object} context - Vuex context
   * @param {Object} params - { start, end, venues, format }
   * @returns {Promise<Blob>} Export file blob
   */
  async exportEventFeedbacks(_context, params = {}) {
    const response = await this.$axios.post('admin/export/shoppingEventSurveys', params, {
      responseType: 'blob',
    })
    return response.data
  },

  /**
   * Fetch the venues that already carry at least one survey response, for the dashboard filter.
   * The endpoint answers with a plain JSON array rather than the usual `{ data: [...] }` envelope
   * and is already ordered by venue name, so the payload is handed back untouched.
   * @returns {Promise<Array<Object>>} Rows of { venue, responses, first_response_at, last_response_at }
   */
  fetchVenues() {
    return this.$axios.$get('admin/surveys/shoppingEvent/venues')
  },
}
